import {
  BellRingIcon,
  ClipboardCheckIcon,
  FileTextIcon,
  HeartPulseIcon,
  PillIcon,
  ScaleIcon,
  ShieldCheckIcon,
  StethoscopeIcon,
  UploadIcon,
  UtensilsIcon,
} from 'lucide-react'

export const prescriptionActions = [
  {
    title: 'Upload insurance prescription',
    description: 'Submit your prescription and insurance details for review.',
    path: '/prescription?type=insurance',
    icon: ShieldCheckIcon,
    tone: 'bg-brand-light text-brand',
  },
  {
    title: 'Upload Wasfaty prescription',
    description: 'Enter your Wasfaty details and upload the prescription for review.',
    path: '/prescription?type=wasfaty',
    icon: FileTextIcon,
    tone: 'bg-sage-light text-sage-dark',
  },
  {
    title: 'Upload cash prescription',
    description: 'Upload a prescription and complete payment after approval.',
    path: '/prescription?type=cash',
    icon: UploadIcon,
    tone: 'bg-sage-light text-sage-dark',
  },
  {
    title: 'Prescription history',
    description: 'Review prescription status and past orders.',
    path: '/prescription/history',
    icon: ClipboardCheckIcon,
    tone: 'bg-[#edf8f2] text-[#287451]',
  },
  {
    title: 'Order medicine',
    description: 'Browse health essentials and add what you need to your cart.',
    path: '/categories',
    icon: PillIcon,
    tone: 'bg-[#f3f8ed] text-[#427941]',
  },
] as const

export const careActions = [
  {
    title: 'Ask a pharmacist',
    description: 'Get support with medicines, dosage, and product choices.',
    path: '/pharmacist-consultation',
    icon: StethoscopeIcon,
    tone: 'bg-[#eef8fa] text-[#25717c]',
    badge: '24/7',
  },
  {
    title: 'Free doctor consultation',
    description: 'Talk to a doctor for general health guidance.',
    path: '/doctor-consultation',
    icon: HeartPulseIcon,
    tone: 'bg-[#fff1f3] text-[#a5475a]',
    badge: 'FREE',
  },
] as const

export const wellnessTools = [
  {
    title: 'BMI calculator',
    description: 'Understand your healthy weight range.',
    path: '/bmi-calculator',
    icon: ScaleIcon,
    tone: 'bg-[#fff7e8] text-[#a66b12]',
  },
  {
    title: 'AI nutrition & diet',
    description: 'Build a plan around your goals.',
    path: '/nutrition-calculator',
    icon: UtensilsIcon,
    tone: 'bg-[#eff7ed] text-[#427941]',
  },
  {
    title: 'Medicine reminders',
    description: 'Stay on track with your daily medicines.',
    path: '/medicine-reminder',
    icon: BellRingIcon,
    tone: 'bg-[#f4f1ff] text-[#684eac]',
  },
] as const
